import React, { Component } from 'react'
import * as Azure from "@azure/storage-blob";
import * as path from "path";

import gql from "graphql-tag";

import { Icon, Button } from 'office-ui-fabric-react/lib';
import { MyContext } from '../../context';
import Utils from "../common/Utils";
import "./Setter.scss";

const ONE_MINUTE = 60 * 1000;
const aborter = Azure.Aborter.timeout(30 * ONE_MINUTE);
const content = "Test!";
const validFilename = require('valid-filename');

export default class UploadMappingFile extends Component {
    constructor(props) {
        super(props);

        this.fileInputRef = React.createRef();

        this.state = {
            auth: props.authorization,
            uploadActive: false,
            contactButtonActive: false,
        }
    }

    getBlockSize(file) {
        const size32Mb = 1024 * 1024 * 32;
        const size4Mb = 1024 * 1024 * 4;
        const size512Kb = 1024 * 512;

        return file.size > size32Mb ? size4Mb : size512Kb;
    }

    getDownloadUrl = async (file) => {
        if (file !== null && file !== "") {
            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent ($input: AuthInput, $fileName:String) {
                        createImportMappingFileBlobSas (input: $input, fileName:$fileName)
                    }
                    `,
                    variables: { input: this.props.authorization, fileName: file }
                }).then(async result => {
                    this.setState({ downloadURL: result.data.createImportMappingFileBlobSas });
                });

        } else {
            return;
        }
    }

    async execute(file) {
        // Get SAS url for write access to Blob Storage
        this.props.apol
            .mutate({
                mutation: gql`
                mutation ent ($input: AuthInput) {
                    createImportMappingFileBlob (input: $input)
                }
                `,
                variables: { input: this.props.authorization }
            })
            .then(async result => {

                const anonymousCredential = new Azure.AnonymousCredential();
                const pipeline = Azure.StorageURL.newPipeline(anonymousCredential);
                if (result.data.createImportMappingFileBlob === "NO LICENSE") {
                    document.getElementById(this.props.idResult).innerHTML = "No License. Please buy one from ASC Technologies AG";

                    this.setState({ uploadActive: false, contactButtonActive: true });
                }
                else {
                    const serviceURL = new Azure.ServiceURL(result.data.createImportMappingFileBlob, pipeline);

                    const containerURL = Azure.ContainerURL.fromServiceURL(serviceURL, "");

                    const fileName = file.name;

                    if (!validFilename(fileName)) {
                        document.getElementById(this.props.idResult).innerHTML = "";
                        document.getElementById(this.props.idError).innerHTML = "No valid filename"
                    } else {

                        const blockBlobURL = Azure.BlockBlobURL.fromContainerURL(containerURL, fileName);

                        await blockBlobURL.upload(aborter, content, content.length);

                        const options = {
                            blockSize: this.getBlockSize(file), parallelism: 10, progress: (transferProgressEvent) => {
                                document.getElementById(this.props.idResult).innerHTML = "Upload: " + Math.round((transferProgressEvent.loadedBytes / file.size) * 100) + "%"
                                document.getElementById(this.props.idError).innerHTML = " File: " + file.name
                            }
                        };
                        await Azure.uploadBrowserDataToBlockBlob(aborter, file, blockBlobURL, options);


                        document.getElementById(this.props.idResult).innerHTML = "File uploaded";
                        document.getElementById(this.props.idError).innerHTML = "";

                        //notify parent with uploaded file name and base url (without SAS query params)
                        const fullSasUrl = result.data.createImportMappingFileBlob;
                        const baseUrl = fullSasUrl.split("?")[0];
                        this.props.onFileUploaded(fileName, baseUrl);

                    }
                    this.setState({ uploadActive: false });
                }
            });
    };


    render() {
        return (<MyContext.Consumer>{(context) => (<>

            <div style={{ display: "inline" }}
                onClick={async () => {
                    if (this.state.uploadActive || this.props.disabled) return;

                    document.getElementById(this.props.idResult).innerHTML = '';
                    document.getElementById(this.props.idError).innerHTML = '';

                    if (this.fileInputRef.current) {
                        this.fileInputRef.current.click()
                    }
                }}
            >
                <Button disabled={this.state.uploadActive || this.props.disabled} style={{ display: "inline" }}>
                    {context.getTranslation("common", "uploadFile")}
                </Button>

            </div>

            <p style={{ display: "inline", marginRight: "10px", wordBreak: "break-all" }}>{this.props.fileBtnText}</p>


            <div >
                <input type="file"
                    id={this.props.idFiles} onChange={async () => {
                        var files = document.getElementById(this.props.idFiles).files;
                        if (!files.length) {
                            alert('Please select a file');
                        } else {
                            if (!validFilename(files[0])) {
                                alert('Please input a real filename!');
                            } else {
                                document.getElementById(this.props.idResult).innerHTML = 'Log in...';
                                this.setState({ uploadActive: true });
                                document.getElementById(this.props.idResult).innerHTML = 'Upload running...';
                                this.execute(files[0]).then(() => console.log("Done")).catch((e) => {
                                    document.getElementById(this.props.idError).innerHTML = 'Error...' + e; this.setState({ uploadActive: false });
                                });
                            }
                        }
                    }} ref={this.fileInputRef} style={{ display: "none" }} accept=".csv" name="mappingfile" />
                <div style={{ marginTop: "5px" }} id={this.props.idResult}></div>
                <div style={{ marginTop: "5px" }} id={this.props.idError}></div>
            </div>


            <br />

        </>)}</MyContext.Consumer>
        );
    }
}
